import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=7b5ed4ca&scoped=true"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&id=7b5ed4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ed4ca",
  null
  
)

export default component.exports